<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">{{title}}</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <div class="rew19_directdebit">
          <p class="rew19_txtcenter">
            회원님의 휴대폰 번호로 인증번호가 전송되었습니다.<br/>
            전송된 인증번호를 입력하세요.<br/>
            인증번호는 2분간만 유효합니다.
          </p>
          <span class="time_check">{{fmtExpiredTime(viewData.expiredTime)}}</span>

          <ul class="rew19_transition_table">
            <li>
              <em class="with_type1">승인번호입력</em>
              <div class="rew19_form_full">
                <input
                  v-model.trim="viewData.approvalCode"
                  ref="approvalCode"                  
                  maxlength="10" 
                  title="핸드폰 인증번호" type="tel"
                  class="autoFocus rew19_inputTxt_t1" 
                  placeholder="승인번호를 입력하세요.">
              </div>
            </li>
            <li>
              <div class="innerBtns_type1">
                <span class="contents_innerBtns">
                  <a @click="onClickRetry" class="btn-deafult">재발송</a>
                  <a @click="onClickApproval"
                    :class="{on : viewData.expiredTime > 0}"
                    class="btn-deafult">인증</a>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div><!--//rew19_popup_cont-->
      <div class="rew19_popup_btn">
        <button class="rew19_popFull activation" @click="onCancel">닫기</button>
      </div>
    </div>
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

const MAX_EXPIRED_TIME = 120;
const DEFAULT_VIEWDATA = {
  mobilePhoneNum1 : null,
  mobilePhoneNum2 : null,
  mobilePhoneNum3 : null,

  checkedSms : false,
  expiredTime : MAX_EXPIRED_TIME,
  approvalCode : null,
  approvalStatus : null,

  timer : null,
};

export default {
  name: 'SmsApprovalDialog',
  components: {  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      require : true,
    }    
  },
  data() {
    return {
      currentZIndex : 2000,

      viewData : {...DEFAULT_VIEWDATA}      
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;

  },  
  methods :{
    onClose(response) {
      let _this = this;
      
      let resData = {
        checkedSms : _this.viewData.checkedSms,
        approvalStatus : _this.viewData.approvalStatus
      };
      
      _this.$emit('close', response, response ? resData: null);
      clearTimeout(_this.viewData.timer);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */    
    //SMS 인증번호 전송
    apiSendSmsAuth(phoneNumber){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/phones/auth`, {
        params: {
          mobile_phone_num : phoneNumber
        }        
      });
    },

    //SMS 인증번호 확인
    apiCheckSmsAuth(approvalNumber){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/phones/check`, {
        params: {
          approval_number : approvalNumber
        }        
      });
    },        

    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        ...paramData,
      };

      //초기화 동시에 인증번호 요청
      _this.sendRequestApprovalCode();
    },

    //인증 번호 요청
    sendRequestApprovalCode(){
      let _this = this;
      let phoneNum = `${_this.viewData.mobilePhoneNum1}-${_this.viewData.mobilePhoneNum2}-${_this.viewData.mobilePhoneNum3}`;

      //SMS 발송
      _this.viewData.checkedSms = false;
      _this.viewData.expiredTime = MAX_EXPIRED_TIME;
      _this.$showLoading();     
      _this.apiSendSmsAuth(phoneNum).then(res=>{
          
        if (res.status === 200 && res.data.status === "0000") {

          //카운트 다운
          clearTimeout(_this.viewData.timer); 
          _this.countDown();
          return;
        }

        //오류 시 메시지 보이고 dialog close
        _this.viewData.checkedSms = false;          
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        _this.$dialogs.alert(errMsg)
        .then(res => {
          _this.onCancel();
        });        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },    

    //인증만료시간 카운트 다운
    countDown(){      
      this.viewData.timer = setTimeout(function(){
        let _this = this;

        if(_this.viewData.checkedSms){
          return; //인증 완료시 카운트 처리 안함
        }

        _this.viewData.expiredTime--;
        if(_this.viewData.expiredTime > 0){
          _this.countDown();
          return;
        }

        //만료
        _this.viewData.expiredTime = 0;

      }.bind(this), 1000);
    },

    //인증번호 재요청
    onClickRetry(){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'재전송'};
      _this.$dialogs.confirm("승인번호를 다시 요청 하시겠습니까?", options).then(res=>{
        if(res.ok){
          _this.viewData.approvalCode = null;
          _this.sendRequestApprovalCode();
        }
      });      
    },

    //SMS 인증 확인
    onClickApproval(){
      let _this = this;

      if(!_this.validationApprvalCode()){
        return;
      }

      //SMS 발송
      _this.viewData.checkedSms = false;
      _this.$showLoading();
      _this.apiCheckSmsAuth(_this.viewData.approvalCode).then(res=>{
        
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        if (res.status === 200 && res.data.status === "0000") {

          //승인
          _this.viewData.checkedSms = true;
          _this.viewData.approvalStatus = res.data.status;          
          _this.$dialogs.alert(errMsg)
          .then(res => {
            _this.onOk();
          });
          return;
        }
        
        // 미승인
        _this.viewData.checkedSms = false;          
        _this.$dialogs.alert(errMsg)
        .then(res => {});

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });      
    },

    //승인번호 유효성 체크
    validationApprvalCode(){
      //Note: api 에서 체크 하도록 입력값만 확인
      let _this = this;

      if(_this.viewData.expiredTime <= 0){
        _this.$dialogs.alert("인증시간이 만료되었습니다.<br/>재발송 후 다시 시도해 주십시오.")
        .then(res => {
          _this.$refs.approvalCode.focus();
        });
        return false;
      }


      let chVal = "";

      chVal = _this.viewData.approvalCode;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("승인번호를 입력하세요.")
        .then(res => {
          _this.$refs.approvalCode.focus();
        });
        return false;
      }
      
      return true;
    },

    /**
     * Util
     */
    fmtExpiredTime(time){
      if(time <= 0){
        return "만료";
      }

      let retVal = "";
      let min = Math.floor(time / 60);
      let sec = time % 60;

      if(min > 0){
        retVal += `${min}분 `;
      }

      retVal += `${sec}초`;

      return retVal;
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/SmsApprovalDialog.vue